import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import * as Showdown from 'showdown';

import {Language} from 'classes/language';
import {CModule} from 'shared/models/cmodules/cmodule';
import {TranslatedText} from 'shared/models/translated-text';
import {CModulesDetailsService} from './services/cmodules-details.service';
import { TargetGroup, TARGETGROUP_DUMMIES } from 'shared/models/target-groups/target-group';

import {CModuleDatepickerComponent} from './cmodules-datepicker/cmodules-datepicker.component';
import cmodule from '*.json';
import { Subscription } from 'rxjs/Subscription';
import { Dialog } from 'shared/classes/dialog';
import { DragulaService } from 'ng2-dragula';
import { CModuleItem } from 'shared/models/cmodules/cmodule-item';
import { Content } from 'shared/models/contents/content';

@Component({
  selector: 'cmodules-details',
  templateUrl: './cmodules-details.component.html',
  styleUrls: ['./cmodules-details.component.css'],
})
export class CModulesDetailsComponent implements OnInit {

  @ViewChild('startDatepicker') public startDatepicker: CModuleDatepickerComponent;
  @ViewChild('endDatepicker') public endDatepicker: CModuleDatepickerComponent;

  public languages: Array<Language> = Language.defaultLanguages;
  public language: string = this.languages[0].code;
  public cmodule: CModule = {
    title: TranslatedText.createEmptyInstance(),
    description: TranslatedText.createEmptyInstance(),
    keywords: TranslatedText.createEmptyInstance(),
    active: true,
    omnibus: false,
    targetGroups: [],
    targetGroupsPurchasable: [],
    startDate: undefined,
    endDate: undefined,
    orderno: undefined,
    contents: [],
  };
  public errorText: string = null;
  
  public showMarkdownOutput: boolean = false;
  private markdownOutput: {
    de: string,
    en: string,
  };
  private converter: Showdown.Converter = new Showdown.Converter();

  public allTargetGroups: Array<TargetGroup> = [];

  public selectedTargetGroup: TargetGroup;
  public selectableTargetGroups: Array<TargetGroup> = [];

  public selectedTargetGroupPurchasable: TargetGroup;

  private contents: Array<Content> = [];
  public searchTerm: string;

  public availableContents:Array<Content> = [];

  public filteredContents2 = [];
  public contentUsed = [];

  constructor(private cmodulesDetailsService: CModulesDetailsService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private dragulaService: DragulaService) {
    this.converter.setFlavor('github')
  }

  public ngOnInit(): void {
    this.getAllTargetGroups();
    this.markdownOutput = {de: '', en: ''};
    this.activatedRoute.params.map((urlParameters: Params) => {
      return urlParameters['cmoduleId'];
    })
      .subscribe((cmoduleId: string) => {
        if (cmoduleId) {
          this.getCModule(cmoduleId);
        }
      });
    this.activatedRoute.params.map((urlParameters: Params) => {
      return urlParameters['orderno'];
    })
      .subscribe((orderno: number) => {
          this.cmodule.orderno = orderno;
      });

      this.cmodulesDetailsService.getContents()
      .subscribe((contents: Array<Content>) => {
        this.contents = contents;
        this.availableContents = contents;
        if (this.cmodule.contents.length > 0) {
          this.contentUsed = this.cmodule.contents.map(id => this.getContentById(id));
        }
      });

  }

  public onSubmit(): boolean {
    this.cmodule.contents = this.contentUsed.map(content => content._id);
    if (this.cmodule._id) {
      this.updateCModule();
    } else {
      this.saveCModule();
    }
    return true;
  }

  private getCModule(id: string): void {
    this.cmodulesDetailsService.getCModule(id)
      .subscribe((cmodule: CModule) => {
        this.cmodule = cmodule;
        this.updateMarkdown();
        this.startDatepicker.updateUtcDate(cmodule.startDate);
        this.endDatepicker.updateUtcDate(cmodule.endDate);
        if (!cmodule.targetGroups) {
          cmodule.targetGroups = [];
        }
        if (!cmodule.targetGroupsPurchasable) {
          cmodule.targetGroupsPurchasable = [];
        }
        this.selectableTargetGroups = this.allTargetGroups.filter(group => cmodule.targetGroups.filter(group1 => group1._id == group._id).length == 0);
        this.selectableTargetGroups = this.selectableTargetGroups.filter(group => cmodule.targetGroupsPurchasable.filter(group1 => group1._id == group._id).length == 0);
        if (!cmodule.keywords) {
          cmodule.keywords = TranslatedText.createEmptyInstance();
        }
        if (this.contents.length > 0) {
          this.contentUsed = cmodule.contents.map(id => this.getContentById(id));
        }
      });
  }

  private getAllTargetGroups(): void {
    this.cmodulesDetailsService.getAllTargetGroups()
    .subscribe((allTargetGroups) => {
      this.allTargetGroups = allTargetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
      this.selectableTargetGroups = allTargetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
    });
  }

  private getContentById(id: string): Content {
    return this.contents.find(content => content._id == id);
  }

  private saveCModule(): void {
    // this.errorText = this.cmodule.type.validate();
    if (this.errorText != null) {
      return;
    }
    this.cmodulesDetailsService.saveCModule(this.cmodule)
      .subscribe((cmodule: CModule) => {
        this.router.navigateByUrl('/cmodules');
      });
  }

  private updateCModule(): void {
    //this.errorText = this.cmodule.type.validate();
    if (this.errorText != null) {
      return;
    }
    this.cmodulesDetailsService.updateCModule(this.cmodule)
      .subscribe((cmodule: CModule) => {
        this.router.navigateByUrl('/cmodules');
      });
  }

  public setLanguage(language: Language): void {
    this.language = language.code;
  }

  public get caption(): string {
    return this.cmodule._id ? 'Modul bearbeiten' : 'Modul erstellen';
  }

  public get submitButtonText(): string {
    return this.cmodule._id ? 'Speichern' : 'Erstellen';
  }

  private setMarkdownOutput(value: boolean): void {
    this.showMarkdownOutput = value;
  }

  private updateMarkdown(): void {
    this.markdownOutput[this.language] = this.converter.makeHtml(this.cmodule.description[this.language]);
  }

  public selectTargetGroup(group: TargetGroup): void {
    if (this.isTargetGroup(group)) {
      this.cmodule.targetGroups.push(group);
      this.selectableTargetGroups.splice(this.selectableTargetGroups.indexOf(group), 1);
    }
  }

  public deselectTargetGroup(group: TargetGroup): void {
    this.selectableTargetGroups.push(group);
    this.cmodule.targetGroups.splice(this.cmodule.targetGroups.indexOf(group), 1);
  }

  public selectTargetGroupPurchasable(group: TargetGroup): void {
    if (this.isTargetGroup(group)) {
      this.cmodule.targetGroupsPurchasable.push(group);
      this.selectableTargetGroups.splice(this.selectableTargetGroups.indexOf(group), 1);
    }
  }

  public deselectTargetGroupPurchasable(group: TargetGroup): void {
    this.selectableTargetGroups.push(group);
    this.cmodule.targetGroupsPurchasable.splice(this.cmodule.targetGroupsPurchasable.indexOf(group), 1);
  }

  private isTargetGroup(obj: any): obj is TargetGroup {
    return obj._id !== undefined
  }


  public handleStartDateChange(date: Date): void {
    this.cmodule.startDate = date;

    // Don't allow start date to be after the end date
    if (this.endDatepicker.utcDate < this.startDatepicker.utcDate) {
      this.endDatepicker.utcDate = new Date(this.startDatepicker.utcDate.getTime());
      this.cmodule.endDate = new Date(this.cmodule.startDate.getTime());
    }
  }

  public handleEndDateChange(date: Date): void { // tslint:disable-line
    this.cmodule.endDate = date;
  }

  // content list
  public get filteredContents(): Array<Content> {
    const filtered = this.contents.filter((content) => {
      return this.filterBySearchTerm(content);
    });
    filtered.sort(((a, b) => a.title[this.language].localeCompare(b.title[this.language])));
    //this.filteredContents2 =
    return filtered.filter((content) => {
      return !this.contentUsed.includes(content);
    });
    //return filtered;
  }

  private filterBySearchTerm(content: Content): boolean {

    if (!this.searchTerm) {
      return true;
    }

    const searchTerm: string = this.searchTerm.toLowerCase();

    if (content.title[this.language].toLowerCase().includes(searchTerm)) {
      return true;
    }

    if (content.description[this.language].toLowerCase().includes(searchTerm)) {
      return true;
    }

    return false;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-details/cmodules-details.component.ts